/* JF Electrical & Security — Theme JS */
(function () {
  'use strict';

  /* ── Utility ── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);
  const off = (el, ev, fn) => el && el.removeEventListener(ev, fn);

  /* ── Toast notification ── */
  function showToast(msg, type = 'success') {
    let toast = $('#rth-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'rth-toast';
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.className = `toast toast--${type}`;
    toast.innerHTML = type === 'success'
      ? `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg><span>${msg}</span>`
      : `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg><span>${msg}</span>`;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('is-visible'), 3400);
  }

  /* ── Format money ── */
  function formatMoney(cents) {
    const fmt = (window.RTH && window.RTH.moneyFormat) || '£{{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.floor(cents / 100));
  }

  /* ── Overlay ── */
  const overlay = $('#site-overlay');
  let overlayListeners = [];
  function openOverlay(onClose) {
    if (!overlay) return;
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    const fn = () => { closeOverlay(); if (onClose) onClose(); };
    overlayListeners.push(fn);
    on(overlay, 'click', fn, { once: true });
  }
  function closeOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
  }

  /* ── Sticky Header ── */
  (function initHeader() {
    const header = $('.site-header');
    if (!header) return;
    let lastScroll = 0;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 32);
      lastScroll = y;
    };
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ── Announcement Bar Close ── */
  (function initAnnouncementBar() {
    const btn = $('.announcement-bar__close');
    const bar = $('.announcement-bar');
    if (!btn || !bar) return;
    on(btn, 'click', () => { bar.style.display = 'none'; });
  })();

  /* ── Mobile Menu ── */
  (function initMobileMenu() {
    const hamburger = $('.hamburger');
    const menu = $('.mobile-menu');
    const closeBtn = $('.mobile-menu__close');
    if (!hamburger || !menu) return;

    function openMenu() {
      menu.classList.add('is-open');
      hamburger.classList.add('is-active');
      hamburger.setAttribute('aria-expanded', 'true');
      openOverlay(closeMenu);
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      menu.classList.remove('is-open');
      hamburger.classList.remove('is-active');
      hamburger.setAttribute('aria-expanded', 'false');
      closeOverlay();
      document.body.style.overflow = '';
    }
    on(hamburger, 'click', () => menu.classList.contains('is-open') ? closeMenu() : openMenu());
    on(closeBtn, 'click', closeMenu);

    // Submenu toggles
    $$('.mobile-menu__link[data-has-submenu]').forEach(link => {
      on(link, 'click', (e) => {
        e.preventDefault();
        const submenu = link.nextElementSibling;
        if (submenu) submenu.classList.toggle('is-open');
      });
    });
  })();

  /* ── Search Overlay ── */
  (function initSearch() {
    const overlay = $('#search-overlay');
    const openBtns = $$('[data-search-toggle]');
    const closeBtn = $('#search-close');
    const input = overlay && overlay.querySelector('.search-overlay__input');
    if (!overlay) return;

    function openSearch() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(() => input && input.focus(), 300);
    }
    function closeSearch() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtns.forEach(btn => on(btn, 'click', openSearch));
    on(closeBtn, 'click', closeSearch);
    on(document, 'keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
    });
    on(overlay, 'click', (e) => { if (e.target === overlay) closeSearch(); });
  })();

  /* ── Cart State ── */
  const Cart = {
    data: null,
    listeners: [],
    on(fn) { this.listeners.push(fn); },
    emit() { this.listeners.forEach(fn => fn(this.data)); },

    async fetch() {
      try {
        const res = await fetch('/cart.js');
        this.data = await res.json();
        this.emit();
        return this.data;
      } catch (e) { console.error('Cart fetch error', e); }
    },

    async add(variantId, qty = 1, properties = {}) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity: qty, properties })
        });
        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.description || 'Could not add to cart');
        }
        await this.fetch();
        return true;
      } catch (e) {
        showToast(e.message, 'error');
        return false;
      }
    },

    async change(key, qty) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        this.data = await res.json();
        this.emit();
        return this.data;
      } catch (e) { console.error('Cart change error', e); }
    },

    async remove(key) { return this.change(key, 0); }
  };

  /* ── Cart Drawer ── */
  (function initCartDrawer() {
    const drawer = $('.cart-drawer');
    const openBtns = $$('[data-cart-toggle]');
    const closeBtn = $('.cart-drawer__close');
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      openOverlay(closeDrawer);
      document.body.style.overflow = 'hidden';
      Cart.fetch();
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      closeOverlay();
      document.body.style.overflow = '';
    }
    openBtns.forEach(btn => on(btn, 'click', openDrawer));
    on(closeBtn, 'click', closeDrawer);

    /* Render drawer items */
    Cart.on((cart) => {
      if (!cart) return;
      updateCartBadge(cart.item_count);
      renderDrawer(cart);
    });

    function renderDrawer(cart) {
      const itemsEl = drawer.querySelector('.cart-drawer__items');
      const subtotalEl = drawer.querySelector('.cart-drawer__subtotal span:last-child');
      const countEl = drawer.querySelector('.cart-drawer__count');
      if (!itemsEl) return;

      if (countEl) countEl.textContent = cart.item_count;
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      if (cart.item_count === 0) {
        itemsEl.innerHTML = `
          <div class="cart-drawer__empty">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 01-8 0"/>
            </svg>
            <h3>Your cart is empty</h3>
            <p>Add some products to get started</p>
          </div>`;
        return;
      }

      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-drawer__item" data-key="${item.key}">
          <div class="cart-drawer__item-img">
            ${item.image ? `<img src="${item.image.replace('_400x400','_150x150')}" alt="${item.title}" loading="lazy">` : ''}
          </div>
          <div class="cart-drawer__item-info">
            <div class="cart-drawer__item-title">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__item-variant">${item.variant_title}</div>` : ''}
            <div class="cart-drawer__item-row">
              <div class="qty-group">
                <button class="qty-btn" data-action="minus" data-key="${item.key}">−</button>
                <input type="number" class="qty-input" value="${item.quantity}" min="0" data-key="${item.key}">
                <button class="qty-btn" data-action="plus" data-key="${item.key}">+</button>
              </div>
              <div class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</div>
            </div>
          </div>
        </div>
      `).join('');

      // Qty controls in drawer
      $$('.qty-btn', itemsEl).forEach(btn => {
        on(btn, 'click', async () => {
          const key = btn.dataset.key;
          const input = itemsEl.querySelector(`.qty-input[data-key="${key}"]`);
          let qty = parseInt(input.value);
          if (btn.dataset.action === 'plus') qty++;
          else qty = Math.max(0, qty - 1);
          await Cart.change(key, qty);
        });
      });
    }

    // Initial fetch
    Cart.fetch();
  })();

  /* ── Cart Badge ── */
  function updateCartBadge(count) {
    $$('.cart-count-badge').forEach(el => {
      el.textContent = count;
      el.classList.toggle('is-visible', count > 0);
    });
  }

  /* ── Add to Cart forms ── */
  (function initATCForms() {
    on(document, 'submit', async (e) => {
      const form = e.target;
      if (!form.matches('#product-form')) return;
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]') || form.querySelector('[type="submit"]');
      const variantInput = form.querySelector('[name="id"]');
      const qtyInput = form.querySelector('[name="quantity"]');
      if (!variantInput) return;
      const variantId = variantInput.value;
      const qty = qtyInput ? parseInt(qtyInput.value) : 1;
      if (!variantId) return;

      btn && (btn.disabled = true);
      const originalText = btn ? btn.innerHTML : '';
      if (btn) btn.innerHTML = '<span class="spinner"></span> Adding…';

      const ok = await Cart.add(variantId, qty);
      if (ok) {
        showToast('Added to cart!');
        if (window.openRthCartDrawer) window.openRthCartDrawer();
      }

      if (btn) { btn.innerHTML = originalText; btn.disabled = false; }
    });
  })();

  /* ── Quick Add ── */
  (function initQuickAdd() {
    on(document, 'click', async (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      const variantId = btn.dataset.quickAdd;
      if (!variantId) return;
      btn.innerHTML = '<span class="spinner"></span>';
      btn.disabled = true;
      const ok = await Cart.add(variantId);
      if (ok) {
        showToast('Added to cart!');
        if (window.openRthCartDrawer) window.openRthCartDrawer();
      }
      btn.innerHTML = 'Add to Cart';
      btn.disabled = false;
    });
  })();

  /* ── Variant Selector ── */
  (function initVariants() {
    $$('.variant-btn').forEach(btn => {
      on(btn, 'click', () => {
        const siblings = $$('.variant-btn', btn.closest('.variant-options'));
        siblings.forEach(s => s.classList.remove('is-active'));
        btn.classList.add('is-active');
        // Update hidden input
        const form = btn.closest('form');
        if (form) {
          const idx = btn.closest('[data-option-index]');
          // Basic first-option variant matching
          updateVariantId(form);
        }
      });
    });

    function updateVariantId(form) {
      // Let Shopify handle variant selection via product.variants data
      // This hooks into the existing hidden input
    }
  })();

  /* ── Quantity Inputs ── */
  (function initQtyInputs() {
    on(document, 'click', (e) => {
      const btn = e.target.closest('.qty-btn:not([data-key])');
      if (!btn) return;
      const group = btn.closest('.qty-group');
      if (!group) return;
      const input = group.querySelector('.qty-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'plus') val++;
      else val = Math.max(1, val - 1);
      input.value = val;
    });
  })();

  /* ── Product Gallery ── */
  (function initProductGallery() {
    const thumbs = $$('.product-thumb');
    const mainImg = $('#product-featured-img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(thumb => {
      on(thumb, 'click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const src = thumb.querySelector('img')?.src.replace('_150x150', '_900x900');
        if (src) mainImg.src = src;
      });
    });
  })();

  /* ── Product Tabs ── */
  (function initProductTabs() {
    $$('.tab-btn').forEach(btn => {
      on(btn, 'click', () => {
        const tabId = btn.dataset.tab;
        const wrap = btn.closest('.product-tabs');
        if (!wrap) return;
        $$('.tab-btn', wrap).forEach(b => b.classList.remove('is-active'));
        $$('.tab-panel', wrap).forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        const panel = wrap.querySelector(`.tab-panel[data-tab="${tabId}"]`);
        if (panel) panel.classList.add('is-active');
      });
    });
  })();

  /* ── FAQ Accordion ── */
  (function initFAQ() {
    $$('.faq-trigger').forEach(trigger => {
      on(trigger, 'click', () => {
        const item = trigger.closest('.faq-item');
        const isOpen = item.classList.contains('is-open');
        // Close all
        $$('.faq-item.is-open').forEach(i => i.classList.remove('is-open'));
        if (!isOpen) item.classList.add('is-open');
      });
    });
  })();

  /* ── Testimonials Slider ── */
  (function initSlider() {
    const track = $('.testimonials-track');
    if (!track) return;
    const cards = $$('.testimonial-card', track);
    if (cards.length < 2) return;
    let current = 0;
    const perView = window.innerWidth >= 1024 ? 3 : window.innerWidth >= 640 ? 2 : 1;
    const max = Math.max(0, cards.length - perView);
    const dots = $$('.slider-dot');

    function goTo(idx) {
      current = Math.max(0, Math.min(max, idx));
      const cardWidth = cards[0].offsetWidth + 24;
      track.style.transform = `translateX(-${current * cardWidth}px)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    const prev = $('.slider-btn[data-dir="prev"]');
    const next = $('.slider-btn[data-dir="next"]');
    on(prev, 'click', () => goTo(current - 1));
    on(next, 'click', () => goTo(current + 1));
    dots.forEach((dot, i) => on(dot, 'click', () => goTo(i)));

    // Auto-advance
    let auto = setInterval(() => goTo(current >= max ? 0 : current + 1), 5000);
    on(track, 'mouseenter', () => clearInterval(auto));
    on(track, 'mouseleave', () => { auto = setInterval(() => goTo(current >= max ? 0 : current + 1), 5000); });

    // Touch support
    let touchStartX = 0;
    on(track, 'touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    on(track, 'touchend', (e) => {
      const dx = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(dx) > 40) goTo(dx > 0 ? current + 1 : current - 1);
    });

    goTo(0);
  })();

  /* ── Scroll Reveal ── */
  (function initReveal() {
    const els = $$('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('is-revealed'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(el => io.observe(el));
  })();

  /* ── Animated Counters ── */
  (function initCounters() {
    const els = $$('[data-counter]');
    if (!els.length) return;
    const animate = (el) => {
      const target = parseFloat(el.getAttribute('data-counter'));
      const decimals = (el.getAttribute('data-counter').split('.')[1] || '').length;
      const suffix = el.getAttribute('data-counter-suffix') || '';
      const duration = 1400;
      const start = performance.now();
      function tick(now) {
        const p = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - p, 3);
        const val = target * eased;
        el.textContent = val.toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(tick);
        else el.textContent = target.toFixed(decimals) + suffix;
      }
      requestAnimationFrame(tick);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(animate); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { animate(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(el => io.observe(el));
  })();

  /* ── Magnetic Buttons ── */
  (function initMagnetic() {
    const els = $$('[data-magnetic]');
    if (!els.length || window.matchMedia('(pointer: coarse)').matches) return;
    els.forEach((el) => {
      on(el, 'mousemove', (e) => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) * 0.25;
        const y = (e.clientY - r.top - r.height / 2) * 0.35;
        el.style.transform = `translate(${x}px, ${y}px)`;
      });
      on(el, 'mouseleave', () => { el.style.transform = ''; });
    });
  })();

  /* ── Portfolio Filter ── */
  (function initPortfolioFilter() {
    const tabs = $$('[data-portfolio-filter]');
    const items = $$('[data-portfolio-item]');
    if (!tabs.length || !items.length) return;
    tabs.forEach((tab) => {
      on(tab, 'click', () => {
        const cat = tab.getAttribute('data-portfolio-filter');
        tabs.forEach(t => t.classList.toggle('is-active', t === tab));
        items.forEach((item) => {
          const match = cat === 'all' || item.getAttribute('data-portfolio-item') === cat;
          item.style.display = match ? '' : 'none';
        });
      });
    });
  })();

  /* ── Hero image pan ── */
  (function initHero() {
    const hero = $('.hero');
    if (!hero) return;
    setTimeout(() => hero.classList.add('is-visible'), 100);
  })();

  /* ── Collection Sort ── */
  (function initCollectionSort() {
    const sortSelect = $('.collection-sort select');
    if (!sortSelect) return;
    on(sortSelect, 'change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
    // Pre-select current
    const url = new URL(window.location.href);
    const current = url.searchParams.get('sort_by');
    if (current) sortSelect.value = current;
  })();

  /* ── Cart Page (full page cart) ── */
  (function initCartPage() {
    const cartForm = $('.cart-page-form');
    if (!cartForm) return;
    on(cartForm, 'change', async (e) => {
      const input = e.target;
      if (!input.matches('.cart-qty-input')) return;
      const key = input.dataset.key;
      const qty = parseInt(input.value);
      if (isNaN(qty)) return;
      await Cart.change(key, qty);
      window.location.reload();
    });
    $$('.cart-remove-btn').forEach(btn => {
      on(btn, 'click', async () => {
        const key = btn.dataset.key;
        await Cart.remove(key);
        window.location.reload();
      });
    });
  })();

  /* ── Newsletter ── */
  (function initNewsletter() {
    const forms = $$('.newsletter-form, .newsletter-form-inline');
    forms.forEach(form => {
      on(form, 'submit', async (e) => {
        // Let Shopify handle the form submit but show feedback
        const input = form.querySelector('input[type="email"]');
        if (!input || !input.value) {
          e.preventDefault();
          showToast('Please enter your email address', 'error');
          return;
        }
        // Allow native submit for Shopify customer newsletter
      });
    });
  })();

  /* ── Announcement close persistence ── */
  (function initAnnouncementPersist() {
    const KEY = 'rth-bar-closed';
    const bar = $('.announcement-bar');
    const btn = $('.announcement-bar__close');
    if (!bar || !btn) return;
    if (sessionStorage.getItem(KEY)) { bar.style.display = 'none'; return; }
    on(btn, 'click', () => { sessionStorage.setItem(KEY, '1'); bar.style.display = 'none'; });
  })();

  /* ── Image lazy fallback ── */
  (function initImages() {
    $$('img[loading="lazy"]').forEach(img => {
      img.addEventListener('error', () => {
        img.style.display = 'none';
      });
    });
  })();

})();

/* RTH final patch: robust mobile submenu + product variants */
(function () {
  function money(cents) {
    var fmt = (window.RTH && window.RTH.moneyFormat) || '£{{amount}}';
    var amount = (Number(cents || 0) / 100).toFixed(2);
    return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(Number(cents || 0) / 100));
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.mobile-menu__link--toggle,[data-has-submenu]');
    if (!toggle || !toggle.closest('.mobile-menu')) return;
    e.preventDefault();
    var submenu = toggle.nextElementSibling;
    if (!submenu) return;
    var open = submenu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('DOMContentLoaded', function () {
    var jsonEl = document.getElementById('ProductJson');
    var form = document.getElementById('product-form');
    if (!jsonEl || !form) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var variantInput = document.getElementById('variant-id');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare]');
    var submit = form.querySelector('[data-add-to-cart]');
    var selected = [];

    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = Number(group.getAttribute('data-option-index'));
      var active = group.querySelector('.variant-btn.is-active') || group.querySelector('.variant-btn');
      if (active) selected[idx] = active.getAttribute('data-value');
    });

    function updateVariant() {
      var variant = product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      }) || product.variants[0];
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (submit) {
        submit.setAttribute('data-add-to-cart', variant.id);
        submit.disabled = !variant.available;
        submit.classList.toggle('is-disabled', !variant.available);
      }
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }
    }

    form.querySelectorAll('.variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-index]');
        if (!group) return;
        var idx = Number(group.getAttribute('data-option-index'));
        group.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selected[idx] = btn.getAttribute('data-value');
        updateVariant();
      });
    });
    updateVariant();
  });
})();
/* JF London Image Popup */
(function () {
  function initJfLondonPopup() {
    var config = window.JF_LONDON_POPUP;

    if (!config || !config.enabled || !config.image) return;
    if (document.body.dataset.jfLondonPopupReady === 'true') return;

    document.body.dataset.jfLondonPopupReady = 'true';

    var canStore = true;

    try {
      sessionStorage.setItem('__jf_popup_test__', '1');
      sessionStorage.removeItem('__jf_popup_test__');
    } catch (error) {
      canStore = false;
    }

    if (canStore && sessionStorage.getItem(config.storageKey) === 'true') {
      return;
    }

    var style = document.createElement('style');

    style.textContent = `
  .jf-london-image-popup {
    position: fixed;
    inset: 0;
    z-index: 2147483647;
    display: none;
    align-items: center;
    justify-content: center;
    padding: clamp(12px, 3vw, 34px);
    pointer-events: none;
    isolation: isolate;
  }

  .jf-london-image-popup.is-open {
    display: flex;
    pointer-events: auto;
  }

  .jf-london-image-popup__backdrop {
    position: absolute;
    inset: 0;
    z-index: 1;
    background:
      radial-gradient(circle at 50% 18%, rgba(18, 130, 162, 0.24), transparent 34%),
      rgba(0, 0, 0, 0.78);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    opacity: 0;
    animation: jfPopupBackdropIn 0.65s ease forwards;
  }

  .jf-london-image-popup__panel {
    position: relative;
    z-index: 2;

    width: auto;
    height: auto;
    max-width: min(980px, calc(100vw - 28px));
    max-height: calc(100dvh - 28px);

    display: inline-flex;
    align-items: center;
    justify-content: center;

    overflow: hidden;
    background: #02070e;
    border: 1px solid rgba(254, 252, 251, 0.16);
    box-shadow:
      0 44px 140px rgba(0, 0, 0, 0.82),
      0 0 72px rgba(18, 130, 162, 0.22),
      inset 0 1px 0 rgba(255, 255, 255, 0.14);

    opacity: 0;
    transform: perspective(1100px) translateY(38px) scale(0.925) rotateX(8deg);
    animation: jfPopupPanelIn 0.95s cubic-bezier(.16, 1, .3, 1) forwards;
  }

  .jf-london-image-popup__panel::before {
    content: "";
    position: absolute;
    inset: -2px;
    z-index: 4;
    pointer-events: none;
    background: linear-gradient(90deg, transparent, rgba(18, 130, 162, 0.38), transparent);
    transform: translateX(-140%);
    animation: jfPopupScan 3.8s ease-in-out infinite 0.8s;
    mix-blend-mode: screen;
    opacity: 0.62;
  }

  .jf-london-image-popup__panel::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 5;
    pointer-events: none;
    border: 1px solid rgba(18, 130, 162, 0.34);
    box-shadow:
      inset 0 0 0 1px rgba(255, 255, 255, 0.04),
      inset 0 0 46px rgba(18, 130, 162, 0.10);
  }

  .jf-london-image-popup__image-link {
    display: inline-flex;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    line-height: 0;
    text-decoration: none;
  }

  .jf-london-image-popup__image {
    display: block;
    width: auto;
    height: auto;

    max-width: min(980px, calc(100vw - 28px));
    max-height: calc(100dvh - 28px);

    object-fit: contain;
    background: #02070e;
  }

  .jf-london-image-popup__close {
    position: absolute;
    top: 14px;
    right: 14px;
    z-index: 10;
    width: 46px;
    height: 46px;
    border: 1px solid rgba(254, 252, 251, 0.24);
    background: rgba(0, 0, 0, 0.42);
    color: #fff;
    cursor: pointer;
    font-size: 32px;
    line-height: 1;
    display: grid;
    place-items: center;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    transition:
      transform 0.25s ease,
      background 0.25s ease,
      border-color 0.25s ease;
  }

  .jf-london-image-popup__close:hover {
    transform: rotate(90deg) scale(1.06);
    background: rgba(18, 130, 162, 0.28);
    border-color: rgba(18, 130, 162, 0.62);
  }

  .jf-london-image-popup.is-closing .jf-london-image-popup__backdrop {
    animation: jfPopupBackdropOut 0.42s ease forwards;
  }

  .jf-london-image-popup.is-closing .jf-london-image-popup__panel {
    animation: jfPopupPanelOut 0.42s ease forwards;
  }

  @keyframes jfPopupBackdropIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes jfPopupBackdropOut {
    from { opacity: 1; }
    to { opacity: 0; }
  }

  @keyframes jfPopupPanelIn {
    0% {
      opacity: 0;
      transform: perspective(1100px) translateY(38px) scale(0.925) rotateX(8deg);
      filter: blur(8px);
    }
    58% {
      opacity: 1;
      transform: perspective(1100px) translateY(-7px) scale(1.018) rotateX(0deg);
      filter: blur(0);
    }
    100% {
      opacity: 1;
      transform: perspective(1100px) translateY(0) scale(1) rotateX(0deg);
      filter: blur(0);
    }
  }

  @keyframes jfPopupPanelOut {
    from {
      opacity: 1;
      transform: perspective(1100px) translateY(0) scale(1) rotateX(0deg);
      filter: blur(0);
    }
    to {
      opacity: 0;
      transform: perspective(1100px) translateY(24px) scale(0.96) rotateX(-5deg);
      filter: blur(5px);
    }
  }

  @keyframes jfPopupScan {
    0%, 35% { transform: translateX(-140%); }
    65%, 100% { transform: translateX(140%); }
  }

  @media screen and (max-width: 749px) {
    .jf-london-image-popup {
      padding: 10px;
    }

    .jf-london-image-popup__panel {
      max-width: calc(100vw - 20px);
      max-height: calc(100dvh - 20px);
    }

    .jf-london-image-popup__image {
      max-width: calc(100vw - 20px);
      max-height: calc(100dvh - 20px);
    }

    .jf-london-image-popup__close {
      top: 8px;
      right: 8px;
      width: 40px;
      height: 40px;
      font-size: 28px;
      background: rgba(0, 0, 0, 0.52);
    }
  }
`;

    document.head.appendChild(style);

    var popup = document.createElement('div');
    popup.className = 'jf-london-image-popup';
    popup.setAttribute('aria-hidden', 'true');

    popup.innerHTML =
      '<div class="jf-london-image-popup__backdrop" data-jf-london-popup-close></div>' +
      '<div class="jf-london-image-popup__panel" role="dialog" aria-modal="true" aria-label="Now live in London">' +
        '<button type="button" class="jf-london-image-popup__close" data-jf-london-popup-close aria-label="Close popup">×</button>' +
        '<a href="' + config.link + '" class="jf-london-image-popup__image-link">' +
          '<img src="' + config.image + '" class="jf-london-image-popup__image" alt="JF Electrical and Security Systems now live in London">' +
        '</a>' +
      '</div>';

    document.body.appendChild(popup);

    var image = popup.querySelector('.jf-london-image-popup__image');
    var delay = Number(config.delay) || 10000;

    function lockPage(lock) {
      document.documentElement.style.overflow = lock ? 'hidden' : '';
      document.body.style.overflow = lock ? 'hidden' : '';
    }

    function openPopup() {
      if (canStore) {
        sessionStorage.setItem(config.storageKey, 'true');
      }

      popup.classList.remove('is-closing');
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      lockPage(true);
    }

    function closePopup() {
      popup.classList.add('is-closing');

      window.setTimeout(function () {
        popup.classList.remove('is-open');
        popup.classList.remove('is-closing');
        popup.setAttribute('aria-hidden', 'true');
        lockPage(false);
      }, 430);
    }

    popup.querySelectorAll('[data-jf-london-popup-close]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closePopup();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) {
        closePopup();
      }
    });

    function startTimer() {
      window.setTimeout(openPopup, delay);
    }

    if (image && !image.complete) {
      image.addEventListener('load', startTimer, { once: true });
      image.addEventListener('error', startTimer, { once: true });
    } else {
      startTimer();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJfLondonPopup);
  } else {
    initJfLondonPopup();
  }
})();
